import { CircleAlert } from 'lucide-react';

import type { components } from 'wg-api-sdk';

import cn from '@/lib/utils/cn';

type Props = {
  recommendation: components['schemas']['OnesuranceRecommendation'];
};

export default function RecommendationNotes({ recommendation }: Props) {
  return (
    <ul className="text-muted-foreground flex flex-col gap-1 text-xs">
      {recommendation.notes?.map((note) => (
        <li key={note} className="flex items-start gap-2">
          <CircleAlert
            className={cn(
              'size-4 shrink-0 text-neutral-800 dark:text-neutral-300',
              {
                ['text-red-500 dark:text-red-400']:
                  recommendation.level === 'HIGH',
                ['text-yellow-500 dark:text-yellow-400']:
                  recommendation.level === 'MEDIUM',
              },
            )}
          />

          {note}
        </li>
      ))}
    </ul>
  );
}
